import clsx from 'clsx'

interface Props {
	label: string
	value: string
	description: string
}

const NumericItem: React.FC<Props> = ({ label, value, description }) => {
	return (
		<div className="request-card-numeric-item">
			<div className="value">{value}</div>
			<img src="/media/stepper/purple-check-stepper-icon.svg" alt="Step Icon Base Blue" />
			<div className="label fw-bold text-kumopack-grey-700">{label}</div>
			<div
				className={clsx('date text-kumopack-grey-600 fs-8')}
				dangerouslySetInnerHTML={{
					__html: description.length === 0 ? '&nbsp' : description,
				}}></div>
		</div>
	)
}

export default NumericItem
